export default __webpack_public_path__ + "static/shark_old-2d3d157f905b9ca3f3c36c8e88b84e3e.gif";